<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心              </p>
	</div>
   <div class="mem-full">

 <Center title='6' />

<div class="mem-con">

	<div class="mem-jin">
		會員中心 / <b>基本情况</b>

	</div>
	<div class="login-r1">
	<div class="re-tit add-ship">
	
		<el-row gutter="50">
			<!-- <el-col span="2">
				<img src="../../assets/peo.png" />
			</el-col> -->
			<el-col span="24">
				<h3>{{ruleForm.username}}</h3>
				<p>{{ruleForm.first_name}} {{ruleForm.last_name}} {{ruleForm.phone}}</p>
			</el-col>
		</el-row>
		
	</div>
	<div class="add-for">
	
	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini">
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="名字" prop="first_name">
	    <el-input v-model="ruleForm.first_name"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="姓" prop="last_name">
	    <el-input v-model="ruleForm.last_name"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Email" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="生日" prop="birthday">
		    <el-date-picker type="date" placeholder="Date of Birth" v-model="ruleForm.birthday" ></el-date-picker>
	
	  </el-form-item>
	  </el-col>
	 </el-row>

	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="電話" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="昵稱" prop="nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	<el-form-item label="國家/地區"  prop="country">
	   <el-select v-model="ruleForm.country" placeholder="請填寫國家">
	     <el-option v-for="item in sun" :label="item.DESCRIPTION" :value="item.DESCRIPTION"></el-option>
		  
	   </el-select>
	 </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="大陸和臺灣必須填寫身份證號碼"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="詳細地址" prop="line_account">
	    <el-input v-model="ruleForm.line_account"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>

	 <el-row :gutter="20">
	 			 <el-col :span="8">
	  <el-form-item label="省" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="城鎮/都市" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="8">
	  <el-form-item label="郵遞區號" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row>

	  </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="Instagram" prop="instagram">
	    <el-input v-model="ruleForm.instagram"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="Facebook" prop="facebook_id">
	    <el-input v-model="ruleForm.facebook_id"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	<div class="h-button" @click="submitForm('ruleForm')">保存</div>
	 
	 
	  </el-form-item>
	</el-form>
	
	</div>
	</div>

	
</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center
  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		sun:'',
		news:'',
           ruleForm: {
           	first_name:'',
           	last_name:'',
			birthday:'',
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	line_account:'',
           	province:'',
           	city:'',
           	postcode:'',
			moren: 0,
			instagram:'',
			facebook_id:''
          
               
                 },
           
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
		
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_editInfo",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					this.sandMate()
		  
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },
			  sandMate(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=users_userInfo",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  	
			  							
			  			this.ruleForm=data.data;
			  			
			  			
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			margin-bottom: 20px;
			h4{
				font-size: 26px;
				
			}
			
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
padding: 30px;
	background: #FFFFFF;
	border: 1px solid #D2D2D2;
	

}
.add-ship{
	border: 1px solid #D2D2D2;
	background: #F8F8F8;
	padding: 30px;
	h3{
		font-size: 18px;
		color: #0A0A0A;
		margin: 6px 0;
	}
}
.add-set{
	margin-left: 10px;
}
</style>